import { globalActor } from "../../state/GlobalContextProvider";

export default function Disclaimer() {
  return (
    <div className="Screen Disclaimer">
      <div>
        <div>
          <section>
            <h2>INDICATION</h2>
            <p>
              MIEBO® (perfluorohexyloctane ophthalmic solution) is indicated for
              the treatment of the signs and symptoms of dry eye disease.
            </p>
          </section>
          <section>
            <h2>IMPORTANT SAFETY INFORMATION</h2>
            <ul>
              <li>
                <span>
                  MIEBO is contraindicated in patients with known
                  hypersensitivity to perfluorohexyloctane
                </span>
              </li>
              <li>
                <span>
                  MIEBO should not be administered while wearing contact lenses.
                  Contact lenses should be removed before use and for at least
                  30 minutes after administration of MIEBO
                </span>
              </li>
              <li>
                <span>
                  Instruct patients to instill one drop of MIEBO into each eye
                  four times daily
                </span>
              </li>
              <li>
                <span>
                  The safety and efficacy in pediatric patients below the age of
                  18 have not been established
                </span>
              </li>
              <li>
                <span>
                  In pivotal trials, the most common ocular adverse reaction was
                  blurred vision (1% to 3% of patients reported blurred vision
                  and conjunctival redness)
                </span>
              </li>
            </ul>
          </section>
          <p>
            Tap{" "}
            <a
              href="https://www.bausch.com/globalassets/pdf/packageinserts/pharma/miebo-package-insert.pdf"
              target="_blank"
              onClick={(_) =>
                window.gaEvent({ event: "prescribe_information_clicked" })
              }
            >
              here
            </a>{" "}
            for full Prescribing Information for MIEBO.
          </p>
          <p>
            You are encouraged to report negative side effects of prescription
            drugs to the FDA. Visit{" "}
            <a href="https://www.fda.gov/medwatch" target="_blank">
              www.fda.gov/medwatch
            </a>{" "}
            or call <a href="tel:1-800-FDA-1088">1-800-FDA-1088</a>.
          </p>
          <button onClick={(_) => globalActor.send({ type: "CONTINUE" })}>
            CONTINUE
          </button>
        </div>
      </div>
    </div>
  );
}
